module.exports = __webpack_public_path__ + "img/icon-change.fe95bf38.svg";